import { Mask } from "maska";

// Dutch integer: 1.234.567
const integerMask = new Mask({ mask: "#.###.###.###.###.###", reversed: true });

// Dutch currency: 1.234,56  (stored as float euros, e.g. 1234.56)
const currencyEurMask = new Mask({ mask: "#.###.###.###,##", reversed: true });

export const maskInteger = (value: number | null | undefined): string => {
	if (value == null) return "";
	return integerMask.masked(String(Math.round(value)));
};

export const unmaskInteger = (v: string): number | null => {
	const raw = integerMask.unmasked(v);
	return raw ? Number(raw) : null;
};

export const maskCurrencyEur = (value: number | null | undefined): string => {
	if (value == null) return "";
	return currencyEurMask.masked(String(Math.round(value * 100)));
};

export const unmaskCurrencyEur = (v: string): number | null => {
	const raw = currencyEurMask.unmasked(v);
	return raw ? Number(raw) / 100 : null;
};
